import { Component, inject, Signal, computed } from '@angular/core';
import { MediaBlockService } from '../../services/media-block-service';
import { VideoUploader } from '../video-uploader/video-uploader';
import { GpsUploader } from '../gps-uploader/gps-uploader';
import { Coordinate } from '@kinomap-dev/ng-ui-lib/core';
import { SyncroEditor } from '../syncro-editor/syncro-editor';
import { SyncroStatus } from '../syncro-status/syncro-status';

@Component({
  selector: 'app-fullscreen-syncro',
  imports: [VideoUploader, GpsUploader, SyncroEditor, SyncroStatus],
  templateUrl: './fullscreen-syncro-modal.html',
  styleUrl: './fullscreen-syncro-modal.scss',
  host: {
  }
})
export class FullscreenSyncroModal {
  mediaBlockService: MediaBlockService = inject(MediaBlockService);

  speedPoints: Signal<number[]> = computed(() => this.mediaBlockService.rawCorrdinates().map((coordinate: Coordinate) => coordinate.speed));
}
